const InfoEmptySearch = {
  urlImage:
    'https://images.ctfassets.net/16npdkkoi5mj/3qwFPiKgBALr8cN68Y2Lw0/adb174feca02c5f4d939c4105790c7d1/busqueda_no_encontrada.svg',
  text: 'Ups! No encontramos resultados para tu búsqueda.',
}

export default InfoEmptySearch
